import React, { useState, useEffect } from "react";
import { colors } from "../../themes/Colors";
import { BaseButton } from "../atoms";

const ContactUsPopUp = ({ display, setClose }) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      onClick={() => (hover ? null : setClose(false))}
      style={{
        height: display ? "100%" : 0,
        width: "100%",
        position: "fixed",
        zIndex: 101,
        top: 0,
        backgroundColor: colors.bgSecondary,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      <div
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
        style={{
          width: "50%",
          maxWidth: 500,
          maxHeight: 500,
          //   height: "50%",
          paddingBottom: 20,
          minWidth: 400,
          //   minHeight: 400,
          borderRadius: 8,
          backgroundColor: colors.white,
          zIndex: 2,
          position: "absolute",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          WebkitBoxShadow: "0px 0px 7px 2px #00000010",
        }}
      >
        <div
          style={{
            fontSize: 18,
            fontWeight: "bold",
            width: "80%",
            marginTop: 20,
            marginBottom: 20,
            textAlign: "center",
          }}
        >
          CONTACT US
        </div>
        <div
          style={{
            width: "100%",
            flex: 1,
            // borderStyle: "solid",
            display: "flex",
            flexDirection: "column",
            overflowX: "hidden",
            overflowY: "scroll",
            alignItems: "center",
          }}
        >
          Contact information:
          <div>Cell number</div>
          <div>email</div>
          <div>Social media links icons</div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsPopUp;
